import { createFileRoute } from '@tanstack/react-router'
import { internDetailsSearchSchema } from '@/features/my-org-interns/intern-details/model/internDetailsSearch'
import { InternDetailsPage } from '@/pages/internships/ui/InternDetailsPage'
export const Route = createFileRoute('/my-org-interns_/$placementId')({
  validateSearch: internDetailsSearchSchema,
  component: Page,
})
function Page() {
  const { placementId } = Route.useParams()
  return <InternDetailsPage placementId={placementId} source="mine" />
}
